"use client"
import React from 'react';
import { Stack, Paper, Grid, Typography, Box, Container, Card, Divider, Button } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { useDispatch } from 'react-redux';
import { setContactUs } from 'api/session';

const items = [
    // "Tirefax Safety Alerts (TSA’s) identify ‘tire safety issues’ drive customers back into service to buy tires, increasing retention rates",
    // "Tirefax identifies up to a dozen (12) ‘tire safety issues’ but most servicers or mechanics are aware of  just  three (3)",
    // "Tirefax is the expert in the field of tires, tire safety and tire forensics for the auto sector",
    // "Tens of millions of tires with known ‘tire safety issues’ are on the roads every day in the U.S. – these tires a have history of ‘tire failures’ that lead to serious accidents often resulting in catastrophic injuries and even death",
    // "Tirefax provides ‘tire history’ about tires that previously was not available to the auto sector. Tirefax maintains a forensic testing facility that constantly tests tires to identify tires prone to ‘tire failure’",
    // "Tire failures occur due to ‘design defects’ and ‘manufacturing defects’ causing the treads and belts to separate and eventually tear loose at highway speeds – this is the ‘invisible hazard’ on the inside of the tire – what can’t be seen with the human eye!",
    // "Customers and even their mechanics will assume when looking at a tire and its tread that the tire is safe to drive on – but that’s not enough – they don’t know what’s going on inside-the-tire (the invisible hazard)",
    // "Most used vehicles have older tires – and as tires become older more data &amp; tire history becomes available, such as ‘accelerated aging’ issues or history of ‘tire failures’ – but until now, servicers, mechanics, fleets and rental agencies have not had access to this data",
    // "It’s important to know that tires are recalled due to known design or manufacturing defects – but not all defective tires are recalled – although many of these tires should be recalled, many will never be recalled and still on the roads today!",
    // "Although it’s estimated that more than 80% of all car owners service their under-warranty vehicles at their dealership – after the warranty periods ends dealer service departments will lose as much as 70% or 80% or more of their post- warranty customers. Now, dealers have an opportunity to retain their post- warranty customers with Tirefax – ideally, servicing tires before, or shortly after their warranty period ends – even replacing tires prior to their original tires nearing the end of their useful life at 6-year (expiration), this increases customer retention levels by selling more tires",
    // "Tirefax tracks tires of your customers in real-time remotely when Tiretrax ‘notifications’ are deployed to notify customers if any TSA’s (tire safety issues) have been identified – Tirefax will advise vehicle owners not drive on these tires at freeway speeds and to return to their service department to keep them, their family and others safe on the roads",
    // "Once the vehicles go up on the lift, additional work & amp; repairs can be found around the wheel &#39; for, brakes, shocks, struts and alignments",
    // "Without Tirefax, dealers and auto servicers are missing out on servicing and selling tires – customers may defect to service tires and their vehicles elsewhere, losing substantial service department revenue opportunities and customers for life",
    //  "Subscribers may contact our Tiretrax Hotline at 1 - 855 - TIREFAX and speak directly to an analyst at our forensic facility with questions about tires Monday – Friday",
    // "Contact Tirefax today at 1 - 855 - TIREFAX to arrange a demo!"



]

const Bullets = () => {

    const dispatch = useDispatch();

    return (
        <Container
            direction="row"
            disableGutters
            maxWidth={false}
            sx={{
                backgroundColor: "#fff",
                padding: {
                    xs: "20px", md: "50px"
                },
                //backgroundImage: "url(/features1.jpeg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundBlendMode: "brightness(50%)",
                opacity: "1"
            }}
        >
            <Divider />
            <Grid container item display={'flex'} direction={"column"} justifyContent="center" alignItems={'center'} sx={{ marginY: "40px" }}>

                <Button variant='contained' color='warning' sx={{ marginTop: "20px" }}
                    onClick={() => dispatch(setContactUs(true))}>SUBSCRIBE NOW</Button>
                <Typography sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "30px" }}>Schedule a demo with Tirefax today at 1-855-TIREFAX</Typography>
            </Grid>

            <Container
                elevation={0}

                sx={{
                    backgroundColor: "transparent",
                    width: "100%"
                }}
            >

                {items.map((s, i) =>
                    <Grid container item xs={12} key={i} direction={"column"}>
                        <Grid container item xs={12} direction={"row"} sx={{ marginY: "16px" }}>
                            <Grid container item xs={1} direction={"row"} justifyContent={"center"} alignContent={'center'}>
                                <CircleIcon sx={{ fontSize: "30px", color: "orange" }} />
                            </Grid>
                            <Grid container item xs={11} direction={"row"}>
                                <Typography align='justify' sx={{ fontSize: "16px", fontWeight: "normal" }}>{s}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                )}

            </Container>

        </Container>
    )
}

export default Bullets;